import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import { logOut } from '../../features/auth/authSlice'
import Cookies from 'js-cookie';

const baseQuery = fetchBaseQuery(
    {
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: 'include',
        prepareHeaders: (headers, { getState }) => {
            const user = getState().auth.user
            if (user) {
                headers.set("authorization", `Bearer ${user.access_token}`)
            }
            return headers
        },
        validateStatus: (response, result) => {
            if (response.status === 401 || response.status === 403) {
                Cookies.set('auth_user', null);
                Cookies.set('auth_access_token', null);
                return false;
            }
            return true;
        }
    }
)

const baseQueryWithAuthHandling = async (args, api, extraOptions) => {
    let result = baseQuery(args, api, extraOptions)

    if (result?.error?.originalStatus === 401) {
        api.dispatch(logOut())
    }
    return result
}

export const apiSlice = createApi({
    baseQuery: baseQueryWithAuthHandling,
    endpoints: builder => ({}),
    tagTypes: ['SKUGroup', 'SKU', 'ProductFamily', 'Photo']
})